import { useEffect, useState } from 'react';
import { NumericFormat } from 'react-number-format';
import { FcAddRow, FcSynchronize, FcEditImage, FcExport } from 'react-icons/fc';
import { Combobox, ComboboxInput, ComboboxOptions, ComboboxOption } from '@headlessui/react';
import { DatePicker } from 'react-date-picker';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';

import Layout from './components/Layout';
import Button from './components/Button';
import { format } from 'date-fns';
import { AlertError, AlertSuccess, AlertWarning } from './components/Alert';
import Loading from './components/Loading';
import apiClient from './apiClient';
import { useAuth } from './authContext';
import { verifyPin } from './utils/verifyPin';

import Swal from 'sweetalert2';
import { useParams } from 'react-router-dom';
import * as XLSX from 'xlsx-js-style';
// @ts-ignore
import * as FileSaver from 'file-saver';

const inputClass = 'w-full px-3 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent'
const tdLabelClass = 'px-3 py-2 text-sm text-gray-700 font-medium w-2/5 align-middle'
const tdInputClass = 'px-2 py-1.5'

let items = [
    { no: 2, name: "car_model_year", label: "รุ่น/ปี", type: "String", position: "car_left", value: "" },
    { no: 3, name: "car_gear_color", label: "เกียร์/สี", type: "String", position: "car_left", value: "" },
    { no: 4, name: "car_num_engines", label: "เลขเครื่อง", type: "String", position: "car_left", value: "" },
    { no: 5, name: "car_number", label: "เลขตัวถัง", type: "String", position: "car_left", value: "" },
    { no: 6, name: "car_date_in", label: "วันที่ซื้อ", type: "Date", position: "car_right", value: "" },
    { no: 7, name: "car_date_sell", label: "วันที่ขาย", type: "Date", position: "car_right", value: "" },
    { no: 8, name: "car_miles", label: "เลขไมล์", type: "String", position: "car_right", value: "" },
    { no: 9, name: "car_license_plate", label: "ทะเบียน/เก่า/ใหม่", type: "String", position: "car_right", value: "" },
    { no: 10, name: "car_owner_old", label: "เจ้าของเดิม/โทร", type: "String", position: "car_right", value: "" },
    { no: 11, name: "car_owner_new", label: "เจ้าของใหม่/โทร", type: "String", position: "car_right", value: "" },
    { no: 12, name: "expense_buy_in", label: "ซื้อเข้า", type: "Number", position: "expense", value: "" },
    { no: 13, name: "expense_transportation", label: "ค่าขนส่ง", type: "Number", position: "expense", value: "" },
    { no: 14, name: "expense_com_buy", label: "ค่าคอม - ซื้อ", type: "Number", position: "expense", value: "" },
    { no: 15, name: "expense_com_sell", label: "ค่าคอม - ขาย", type: "Number", position: "expense", value: "" },
    { no: 16, name: "expense_repair_color", label: "ซ่อมสี", type: "Number", position: "expense", value: "" },
    { no: 17, name: "expense_repair_hassock", label: "ซ่อมเบาะ", type: "Number", position: "expense", value: "" },
    { no: 18, name: "expense_repair_engine", label: "ซ่อมเครื่อง", type: "Number", position: "expense", value: "" },
    { no: 19, name: "expense_repair_undercar", label: "ซ่อมช่วงล่าง", type: "Number", position: "expense", value: "" },
    { no: 20, name: "expense_repair_electrical", label: "ซ่อมระบบไฟ", type: "Number", position: "expense", value: "" },
    { no: 21, name: "expense_repair_sound", label: "เครื่องเสียง", type: "Number", position: "expense", value: "" },
    { no: 22, name: "expense_repair_air", label: "ซ่อมแอร์", type: "Number", position: "expense", value: "" },
    { no: 23, name: "expense_film", label: "ฟิล์ม", type: "Number", position: "expense", value: "" },
    { no: 24, name: "expense_max", label: "แม็ก", type: "Number", position: "expense", value: "" },
    { no: 25, name: "expense_rubber", label: "ยาง", type: "Number", position: "expense", value: "" },
    { no: 26, name: "expense_battery", label: "แบตเตอร์รี่", type: "Number", position: "expense", value: "" },
    { no: 27, name: "expense_carcare", label: "คาร์แคร์", type: "Number", position: "expense", value: "" },
    { no: 28, name: "expense_move_destination", label: "ย้ายปลายทาง", type: "Number", position: "expense", value: "" },
    { no: 29, name: "expense_move_in", label: "ย้ายเข้า", type: "Number", position: "expense", value: "" },
    { no: 30, name: "expense_act", label: "ภาษี/พรบ.", type: "Number", position: "expense", value: "" },
    { no: 31, name: "expense_transfer_fee", label: "ค่าโอน", type: "Number", position: "expense", value: "" },
    { no: 32, name: "expense_oil", label: "ค่าน้ำมัน", type: "Number", position: "expense", value: "" },
    { no: 33, name: "expense_accessories", label: "อุปกรณ์ตกแต่ง", type: "Number", position: "expense", value: "" },
    { no: 34, name: "expense_marketing", label: "ค่าการตลาด", type: "Number", position: "expense", value: "" },
    { no: 35, name: "expense_insurance_name", label: "ชื่อบริษัทประกัน", type: "String", position: "expense", value: "" },
    { no: 36, name: "expense_insurance", label: "ยอดประกัน", type: "Number", position: "expense", value: "" },
    { no: 37, name: "expense_other1", label: "อื่นๆ 1", type: "Number", position: "expense", value: "", name2: 'expense_name1', value2: '' },
    { no: 38, name: "expense_other2", label: "อื่นๆ 2", type: "Number", position: "expense", value: "", name2: 'expense_name2', value2: '' },
    { no: 39, name: "expense_other3", label: "อื่นๆ 3", type: "Number", position: "expense", value: "", name2: 'expense_name3', value2: '' },
    { no: 50, name: "expense_other4", label: "อื่นๆ 4", type: "Number", position: "expense", value: "", name2: 'expense_name4', value2: '' },
    { no: 51, name: "expense_other5", label: "อื่นๆ 5", type: "Number", position: "expense", value: "", name2: 'expense_name5', value2: '' },

    { no: 40, name: "income_price", label: "ราคาขาย", type: "Number", position: "income", value: "" },
    { no: 41, name: "bank_name", label: "ชื่อธนาคาร/ลิสซิ่ง", type: "String", position: "income", value: "" },
    { no: 42, name: "income_down", label: "ยอดดาวน์", type: "Number", position: "income", value: "" },
    { no: 43, name: "income_hold_down", label: "ยอดค้างดาวน์", type: "Number", position: "income", value: "" },
    { no: 44, name: "income_insurance_name", label: "ชื่อบริษัทประกัน", type: "String", position: "income", value: "" },
    { no: 45, name: "income_insurance", label: "ยอดประกัน", type: "Number", position: "income", value: "" },
    { no: 46, name: "income_transfer_amount", label: "ยอดโอน", type: "Number", position: "income", value: "" },
    { no: 47, name: "sum_income", label: "รายรับ", type: "Number", position: "sum", value: "" },
    { no: 48, name: "sum_expense", label: "รายจ่าย", type: "Number", position: "sum", value: "" },
    { no: 49, name: "net_profit", label: "กำไรสุทธิ", type: "Number", position: "sum", value: "" },
]

function NewCar() {
    const { carId: urlCarId } = useParams<{ carId: string }>()
    const { userProfile } = useAuth()

    const [isLoading, setLoading] = useState(false)
    const [car_left, setCarLeft] = useState(makeCarLeft())
    const [expense, setExpense] = useState(makeExpense())
    const [income, setIncome] = useState(makeIncome())
    const [car_id, setCarId] = useState(0)
    const [car_date_in, setCarDateIn] = useState(null)
    const [car_date_sell, setCarDateSell] = useState(null)
    const [car_miles, setCarMiles] = useState('')
    const [car_license_plate, setCarLicensePlate] = useState('')
    const [car_owner_old, setCarOwnerOld] = useState('')
    const [car_owner_new, setCarOwnerNew] = useState('')
    const [sum_income, setSumIncome] = useState(0)
    const [sum_expense, setSumExpense] = useState(0)
    const [net_profit, setNetProfit] = useState(0)
    const [formAction, setFormAction] = useState('add')
    const [search_license, setSearchLicense] = useState('')
    const [search_car_number, setSearchCarNumber] = useState('')
    const [cars, setCars] = useState<any>([])
    const [car, setCar] = useState({})
    const [carBrands, setCarBrands] = useState<any[]>([])
    const [car_brand_id, setCarBrandId] = useState(0)
    const [brandQuery, setBrandQuery] = useState('')

    const is_view_sum = String(userProfile?.is_view_sum ?? 0)
    const is_income = String(userProfile?.is_income ?? 0)
    const is_expense = String(userProfile?.is_expense ?? 0)
    const is_export = String(userProfile?.is_export ?? 0)

    function makeCarLeft() { return items.filter(item => item.position === 'car_left') }
    function makeExpense() { return items.filter(item => item.position === 'expense') }
    function makeIncome() { return items.filter(item => item.position === 'income') }

    function getValueByType(cl: any) {
        let type = cl.type
        return type === 'Number' ? cl.value === 'undefined' ? 0 : Number(cl.value) : cl.value
    }

    useEffect(() => {
        apiClient.get('/v1/car-brands').then(res => {
            if (res.data.result === 'success') setCarBrands(res.data.brands || [])
        }).catch(error => console.log('error:', error))
    }, [])

    useEffect(() => {
        if (urlCarId) {
            apiClient.post('/v1/car_search', { search_license: '', search_car_number: '' }).then(res => {
                let allCars = res.data.cars
                let found = allCars.find((c: any) => String(c.car_id) === urlCarId)
                if (found) selectCar(found)
            }).catch(error => console.log('error:', error))
        } else {
            // Reset form when navigating to /newcar without carId
            items.forEach(item => { item.value = ''; if (item.name2) item.value2 = '' })
            setCarLeft(makeCarLeft())
            setExpense(makeExpense())
            setIncome(makeIncome())
            setCarId(0); setCarBrandId(0); setBrandQuery(''); setCarDateIn(null); setCarDateSell(null)
            setCarMiles(''); setCarLicensePlate(''); setCarOwnerOld(''); setCarOwnerNew('')
            setSumIncome(0); setSumExpense(0); setNetProfit(0); setFormAction('add')
        }
    }, [urlCarId])

    useEffect(() => { calSumExpense(); calSumIncome() }, [expense, income])
    useEffect(() => { setNetProfit(sum_income - sum_expense) }, [sum_income, sum_expense])
    useEffect(() => { fillCarToFrom() }, [car])

    function genCarLeftInput(item: any) {
        return <tr key={item.no} className='border-b border-gray-100'>
            <td className={tdLabelClass}>{item.label}</td>
            <td className={tdInputClass}>
                <input type="text" className={inputClass}
                    value={item.value}
                    onChange={(e) => { item.value = e.target.value; setCarLeft([...car_left]) }}
                />
            </td>
        </tr>
    }

    function calSumExpense() {
        let sum = expense.filter(car => car.type === 'Number').reduce((acc, car) => Number(acc) + Number(car.value), 0)
        setSumExpense(isNaN(sum) ? 0 : sum)
    }

    function calSumIncome() {
        let sum = income.filter(car => car.type === 'Number').reduce((acc, car) => Number(acc) + Number(car.value), 0)
        setSumIncome(isNaN(sum) ? 0 : sum)
    }

    function genExpenseInput(item: any) {
        let name2 = item.name2
        if (item.type === 'Number' && name2 === undefined) {
            return <tr key={item.no} className='border-b border-gray-100'>
                <td className={tdLabelClass}>{item.label}</td>
                <td className={tdInputClass}>
                    <NumericFormat value={item.value} className={inputClass}
                        decimalScale={2} allowNegative={false} thousandSeparator="," maxLength={12}
                        onValueChange={(values) => { item.value = String(values.value); setExpense([...expense]) }}
                        onBlur={() => calSumExpense()}
                    />
                </td>
            </tr>
        } else if (item.type === 'Number' && name2 !== undefined) {
            return <tr key={item.no} className='border-b border-gray-100'>
                <td className={tdLabelClass}>
                    <div className='flex items-center gap-1'>
                        <span className='shrink-0 whitespace-nowrap'>{item.label}</span>
                        <input type="text" className={`${inputClass} w-28`}
                            value={item.value2}
                            onChange={(e) => { item.value2 = e.target.value; setExpense([...expense]) }}
                        />
                    </div>
                </td>
                <td className={tdInputClass}>
                    <NumericFormat value={item.value} className={inputClass}
                        decimalScale={2} allowNegative={false} thousandSeparator="," maxLength={12}
                        onValueChange={(values) => { item.value = String(values.value); setExpense([...expense]) }}
                        onBlur={() => calSumExpense()}
                    />
                </td>
            </tr>
        } else if (item.type === 'String') {
            return <tr key={item.no} className='border-b border-gray-100'>
                <td className={tdLabelClass}>{item.label}</td>
                <td className={tdInputClass}>
                    <input type="text" className={inputClass}
                        value={item.value}
                        onChange={(e) => { item.value = e.target.value; setExpense([...expense]) }}
                    />
                </td>
            </tr>
        }
    }

    function genIncomeInput(item: any) {
        if (item.type === 'Number') {
            return <tr key={item.no} className='border-b border-gray-100'>
                <td className={tdLabelClass}>{item.label}</td>
                <td className={tdInputClass}>
                    <NumericFormat value={item.value} className={inputClass}
                        decimalScale={2} allowNegative={false} thousandSeparator=","
                        onValueChange={(values) => { item.value = String(values.floatValue); setIncome([...income]) }}
                        onBlur={() => calSumIncome()}
                    />
                </td>
            </tr>
        } else if (item.type === 'String') {
            return <tr key={item.no} className='border-b border-gray-100'>
                <td className={tdLabelClass}>{item.label}</td>
                <td className={tdInputClass}>
                    <input type="text" className={inputClass}
                        value={item.value}
                        onChange={(e) => { item.value = e.target.value; setIncome([...income]) }}
                    />
                </td>
            </tr>
        }
    }

    async function saveCar() {
        if (car_license_plate === '') { AlertWarning('กรุณากรอกทะเบียนรถ'); return }
        if (car_date_in === '') { AlertWarning('กรุณาเลือกวันที่ซื้อเข้า'); return }

        let data: any = {}
        car_left.map(cl => { data = { ...data, [cl.name]: getValueByType(cl) } })
        data = { ...data, car_brand_id }
        data = { ...data, car_date_in: car_date_in !== null ? format(new Date(car_date_in), 'yyyy-MM-dd') : '' }
        data = { ...data, car_date_sell: car_date_sell !== null ? format(new Date(car_date_sell), 'yyyy-MM-dd') : '' }
        data = { ...data, car_miles: Number(car_miles), car_license_plate, car_owner_old, car_owner_new }
        expense.map(cl => { data = { ...data, [cl.name]: getValueByType(cl) } })
        expense.filter(ex => ex.value2 !== undefined).map(ex2 => { data = { ...data, [ex2.name2]: ex2.value2 } })
        income.map(cl => { data = { ...data, [cl.name]: getValueByType(cl) } })
        data = { ...data, sum_income, sum_expense, net_profit }

        if (formAction === 'add') {
            window.scrollTo(0, 0); setLoading(true)
            setTimeout(() => {
                apiClient.post('/v1/car', data).then(res => {
                    let d = res.data
                    if (d.result === 'success') {
                            Swal.fire({ icon: 'success', title: 'เพิ่มข้อมูลรถเรียบร้อยแล้ว', showConfirmButton: false, timer: 1500 })
                            setCarId(0); setCarBrandId(0); setBrandQuery(''); setCarDateIn(null); setCarDateSell(null); setCarMiles(''); setCarLicensePlate(''); setCarOwnerOld(''); setCarOwnerNew('')
                            setCarLeft(car_left.map(cl => { cl.value = ''; return cl }))
                            setExpense(expense.map(cl => { cl.value = ''; return cl }))
                            setIncome(income.map(cl => { cl.value = ''; return cl }))
                            setSumIncome(0); setSumExpense(0); setNetProfit(0); setFormAction('add')
                        }
                    else if (d.result === 'fail') { AlertWarning('ผิดพลาด: ไม่สามารถเพิ่มข้อมูลรถได้') }
                    setLoading(false)
                }).catch(error => console.log('error:', error))
            }, 1200)
        } else if (formAction === 'edit') {
            const ok = await verifyPin('car_update', `แก้ไขรถ ${brandQuery} ${car_license_plate}`)
            if (ok) {
                window.scrollTo(0, 0); setLoading(true)
                apiClient.put('/v1/car/' + car_id, data).then(res => {
                    let d = res.data
                    if (d.result === 'success') { AlertSuccess('แก้ไขข้อมูลรถเรียบร้อยแล้ว'); setFormAction('edit') }
                    else if (d.result === 'fail') { AlertWarning('ผิดพลาด: ไม่สามารถแก้ไขข้อมูลรถได้') }
                    setLoading(false)
                }).catch(error => console.log('error:', error))
            }
        }
    }

    function clearData() {
        Swal.fire({ title: 'ต้องการล้างข้อมูลใช้หรือไม่ ?', showDenyButton: true, confirmButtonText: 'ล้างข้อมูล', denyButtonText: 'ยกเลิก' })
            .then((result) => {
                if (result.isConfirmed) {
                    setCarId(0); setCarBrandId(0); setBrandQuery(''); setCarDateIn(null); setCarDateSell(null); setCarMiles(''); setCarLicensePlate(''); setCarOwnerOld(''); setCarOwnerNew('')
                    setCarLeft(car_left.map(cl => { cl.value = ''; return cl }))
                    setExpense(expense.map(cl => { cl.value = ''; return cl }))
                    setIncome(income.map(cl => { cl.value = ''; return cl }))
                    setSumIncome(0); setSumExpense(0); setNetProfit(0); setFormAction('add')
                    AlertSuccess('ล้างข้อมูลเรียบร้อยแล้ว')
                }
            })
    }

    function searchCar() {
        apiClient.post('/v1/car_search', { search_license, search_car_number }).then(res => {
            let cars = res.data.cars
            if (cars.length === 0) AlertWarning('ไม่พบข้อมูลรถ')
            else setCars(cars)
        }).catch(error => console.log('error:', error))
    }

    function fillCarToFrom() {
        if (Object.keys(car).length > 0) {
            setCarLeft(car_left.map(cl => { cl.value = (car as any)[cl.name]; return cl }))
            setExpense(expense.map(cl => {
                cl.value = (car as any)[cl.name]
                if (cl.name2 !== undefined) cl.value2 = (car as any)[cl.name2]
                return cl
            }))
            setIncome(income.map(cl => { cl.value = (car as any)[cl.name]; return cl }))
            // @ts-ignore
            setCarDateIn(!car.car_date_in || car.car_date_in === '0000-00-00' ? null : format(new Date(car.car_date_in), 'yyyy-MM-dd'))
            // @ts-ignore
            setCarDateSell(!car.car_date_sell || car.car_date_sell === '0000-00-00' ? null : format(new Date(car.car_date_sell), 'yyyy-MM-dd'))
            // @ts-ignore
            setCarMiles(car.car_miles); setCarLicensePlate(car.car_license_plate); setCarOwnerOld(car.car_owner_old); setCarOwnerNew(car.car_owner_new)
            // @ts-ignore
            setCarBrandId(car.car_brand_id || 0)
            // @ts-ignore
            if (car.car_brand_id) setBrandQuery(car.car_brand || '')
        }
    }

    // @ts-ignore
    function selectCar(car) { setFormAction('edit'); setCarId(car.car_id); setCar(car); setCars([]) }

    function genCarSearch() {
        let rows = cars.map((car: any) => {
            let title = car.car_brand + ' ' + car.car_model_year + ' ' + car.car_gear_color
            return <tr key={car.car_id} className='border-b border-gray-100'>
                <td className='px-3 py-2 text-sm'>{title}<br />เลขตัวถัง: {car.car_number}</td>
                <td className='px-3 py-2 text-sm'>{car.car_license_plate}</td>
                <td className='px-3 py-2 text-center'>
                    <Button variant='primary' size='sm' onClick={() => selectCar(car)}>
                        เลือก
                    </Button>
                </td>
            </tr>
        })
        return <div className='mt-2 mb-2'>
            <div className='bg-white rounded-lg border border-gray-200 overflow-hidden'>
                <table className='w-full text-sm'>
                    <thead><tr className='bg-gray-50 border-b border-gray-200'>
                        <th className='px-3 py-2 text-left font-semibold text-gray-700'>ข้อมูลรถ/เลขตัวถัง</th>
                        <th className='px-3 py-2 text-left font-semibold text-gray-700'>ทะเบียนรถ</th>
                        <th className='px-3 py-2 text-center font-semibold text-gray-700 w-20'>เลือก</th>
                    </tr></thead>
                    <tbody>{rows}</tbody>
                </table>
            </div>
        </div>
    }

    function getCarRight(index: number) {
        switch (index) {
            case 0: return { label: 'วันที่ซื้อ', value: car_date_in }
            case 1: return { label: 'วันที่ขาย', value: car_date_sell }
            case 2: return { label: 'เลขไมล์', value: car_miles }
            case 3: return { label: 'ทะเบียนเก่า/ใหม่', value: car_license_plate }
            case 4: return { label: 'เจ้าของเดิม/โทร', value: car_owner_old }
            case 5: return { label: 'เจ้าของใหม่/โทร', value: car_owner_new }
        }
        return { label: '', value: '' }
    }

    function exportCar() {
        if (formAction === 'add') { AlertError('กรุณาเลือกรถ'); return }
        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
        const fileExtension = '.xlsx'
        let carData: any[] = []
        let car_left_report = JSON.parse(JSON.stringify(car_left))
        car_left_report.push({ no: 50, name: "", label: "", type: "Number", position: "", value: "" })
        // @ts-ignore
        car_left_report.map((cl, index) => {
            let cr = getCarRight(index)
            carData.push({ A: cl.label, B: cl.value, D: cr.label, E: cr.value })
        })

        let subHeader = [{ A: 'รายการจ่าย', B: '', D: 'รายการรับ', E: '' }]
        let financeData: any[] = []
        expense.map((ex, index) => {
            let inc = income[index] === undefined ? { label: "", value: "" } : income[index]
            let incLabel = inc.label
            let incValue = isNaN(Number(inc.value)) ? inc.value : Number(inc.value)
            // @ts-ignore
            if (ex.name2 === undefined) {
                financeData.push({ A: ex.label, B: isNaN(Number(ex.value)) ? ex.value : Number(ex.value), D: incLabel, E: incValue })
            } else {
                let exValue2 = ex.value2
                financeData.push({ A: ex.label + " : " + exValue2, B: isNaN(Number(ex.value)) ? ex.value : Number(ex.value), D: incLabel, E: incValue })
            }
        })
        financeData.push({ A: "", B: "", D: "รายรับ", E: sum_income })
        financeData.push({ A: "", B: "", D: "รายจ่าย", E: sum_expense })
        financeData.push({ A: "รวม", B: sum_expense, D: "กำไรสุทธิ", E: net_profit })

        const reportData = [...carData, ...subHeader, ...financeData]
        const cellTable = { top: { style: 'thin', color: { rgb: "000000" } }, bottom: { style: 'thin', color: { rgb: "000000" } }, left: { style: 'thin', color: { rgb: "000000" } }, right: { style: 'thin', color: { rgb: "000000" } } }
        setLoading(true); window.scrollTo(0, 0)
        setTimeout(() => {
            // @ts-ignore
            const ws = XLSX.utils.json_to_sheet(reportData, { origin: 'A2', skipHeader: true })
            let rangeBorder = { s: { r: 1, c: 0 }, e: { r: 40, c: 4 } }
            for (let R = rangeBorder.s.r; R <= rangeBorder.e.r; ++R) {
                for (let C = rangeBorder.s.c; C <= rangeBorder.e.c; ++C) {
                    let cell = ws[XLSX.utils.encode_cell({ r: R, c: C })]
                    if (!cell) continue
                    cell.s = { border: cellTable }
                }
            }
            let fmtMile = '#,##0'
            let rangeMile = { s: { r: 3, c: 0 }, e: { r: 3, c: 4 } }
            for (let R = rangeMile.s.r; R <= rangeMile.e.r; ++R) {
                for (let C = rangeMile.s.c; C <= rangeMile.e.c; ++C) {
                    let cell = ws[XLSX.utils.encode_cell({ r: R, c: C })]
                    if (!cell || cell.t != 'n') continue
                    cell.z = fmtMile; cell.s = { alignment: { horizontal: "left" }, border: cellTable }
                }
            }
            let rangeTitle = { s: { r: 7, c: 0 }, e: { r: 7, c: 4 } }
            for (let R = rangeTitle.s.r; R <= rangeTitle.e.r; ++R) {
                for (let C = rangeTitle.s.c; C <= rangeTitle.e.c; ++C) {
                    let cell = ws[XLSX.utils.encode_cell({ r: R, c: C })]
                    if (!cell) continue
                    cell.s = { font: { bold: true }, border: cellTable, alignment: { horizontal: "center" } }
                }
            }
            let fmt = '#,##0.00'
            let range = { s: { r: 8, c: 0 }, e: { r: 40, c: 4 } }
            for (let R = range.s.r; R <= range.e.r; ++R) {
                for (let C = range.s.c; C <= range.e.c; ++C) {
                    let cell = ws[XLSX.utils.encode_cell({ r: R, c: C })]
                    if (cell && R >= 38) { cell.s = { font: { bold: true }, border: cellTable } }
                    if (!cell || cell.t != 'n') continue
                    cell.z = fmt
                    if (R >= 38) { cell.s = { alignment: { horizontal: "right" }, font: { bold: true }, border: cellTable } }
                    else { cell.s = { alignment: { horizontal: "right" }, border: cellTable } }
                }
            }
            ws['!cols'] = [{ wch: 20 }, { wch: 20 }, { wch: 20 }, { wch: 20 }]
            let wsrows = []; for (let i = 1; i <= 40; i++) wsrows.push({ hpt: 18 })
            ws['!rows'] = wsrows
            ws["!merges"] = [{ s: { r: 7, c: 0 }, e: { r: 7, c: 1 } }, { s: { r: 7, c: 2 }, e: { r: 7, c: 3 } }]
            const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] }
            XLSX.utils.sheet_add_aoa(ws, [[userProfile?.company_name || '']], { origin: "A1" })
            let currFileName = format(new Date(), 'yyyy-MM-dd')
            const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
            const data = new Blob([excelBuffer], { type: fileType })
            FileSaver.saveAs(data, 'car_' + car_id + '_' + currFileName + fileExtension)
            setLoading(false)
        }, 1400)
    }

    return (
        <Layout>
            <Loading isLoading={isLoading} />
            <div className='bg-white rounded-lg shadow-sm border border-gray-200 p-4 sm:p-6'>

                {/* Search Bar */}
                <div className='bg-rose-100/50 border border-rose-200 rounded-lg p-3 mb-4'>
                    <div className='flex flex-wrap items-center gap-2 justify-center'>
                        <input type='text' placeholder='ค้นหาตามเลขตัวถัง' value={search_car_number}
                            onChange={(e) => setSearchCarNumber(e.target.value)}
                            onKeyDown={(e) => { if (e.key === 'Enter') searchCar() }}
                            className={`${inputClass} w-full sm:w-auto sm:flex-1 max-w-[220px]`} />
                        <input type='text' placeholder='ค้นหาตามป้ายทะเบียน' value={search_license}
                            onChange={(e) => setSearchLicense(e.target.value)}
                            onKeyDown={(e) => { if (e.key === 'Enter') searchCar() }}
                            className={`${inputClass} w-full sm:w-auto sm:flex-1 max-w-[220px]`} />
                        <div className='flex gap-1.5'>
                            <Button variant='dark' size='md' onClick={searchCar}>
                                ค้นหารถ
                            </Button>
                            <Button variant='neutral' size='sm' className='px-2 py-2' onClick={() => { setSearchLicense(''); setSearchCarNumber(''); setCars([]) }}>
                                <FcSynchronize size='20' />
                            </Button>
                        </div>
                    </div>
                    {cars.length > 0 && genCarSearch()}
                </div>

                {/* Car Info — 2 columns */}
                <div className='grid grid-cols-1 md:grid-cols-2 gap-4 mb-4'>
                    {/* Left: car_left fields */}
                    <div>
                        <table className='w-full'>
                            <tbody>
                                <tr className='border-b border-gray-100'>
                                    <td className={tdLabelClass}>ยี่ห้อ</td>
                                    <td className={tdInputClass}>
                                        <Combobox value={car_brand_id} onChange={(id: any) => { setCarBrandId(Number(id) || 0); const found = carBrands.find((b: any) => b.car_brand_id === id); setBrandQuery(found ? found.car_brand_name : '') }}>
                                            <div className='relative'>
                                                <ComboboxInput
                                                    className={inputClass}
                                                    displayValue={() => brandQuery}
                                                    onChange={(e) => setBrandQuery(e.target.value)}
                                                    placeholder='พิมพ์เพื่อค้นหายี่ห้อ'
                                                />
                                                <ComboboxOptions className='absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-lg bg-white border border-gray-200 py-1 text-sm shadow-lg'>
                                                    {carBrands.filter(b => b.car_brand_name.toLowerCase().includes(brandQuery.toLowerCase()) || b.car_brand_abb.toLowerCase().includes(brandQuery.toLowerCase())).map(b => (
                                                        <ComboboxOption key={b.car_brand_id} value={b.car_brand_id} className='px-3 py-1.5 cursor-pointer data-[focus]:bg-blue-50 data-[focus]:text-blue-900'>
                                                            {b.car_brand_name}
                                                        </ComboboxOption>
                                                    ))}
                                                </ComboboxOptions>
                                            </div>
                                        </Combobox>
                                    </td>
                                </tr>
                                {car_left.map(cl => genCarLeftInput(cl))}
                            </tbody>
                        </table>
                    </div>

                    {/* Right: dates, miles, license, owners */}
                    <div>
                        <table className='w-full'>
                            <tbody>
                                <tr className='border-b border-gray-100'>
                                    <td className={tdLabelClass}>วันที่ซื้อ</td>
                                    <td className={tdInputClass}>
                                        <DatePicker value={car_date_in} onChange={(date: any) => setCarDateIn(date)}
                                            format="dd/MM/yyyy" locale="th" dayPlaceholder="dd" monthPlaceholder="mm" yearPlaceholder="yyyy" />
                                    </td>
                                </tr>
                                <tr className='border-b border-gray-100'>
                                    <td className={tdLabelClass}>วันที่ขาย</td>
                                    <td className={tdInputClass}>
                                        <DatePicker value={car_date_sell} onChange={(date: any) => setCarDateSell(date)}
                                            format="dd/MM/yyyy" locale="th" dayPlaceholder="dd" monthPlaceholder="mm" yearPlaceholder="yyyy" />
                                    </td>
                                </tr>
                                <tr className='border-b border-gray-100'>
                                    <td className={tdLabelClass}>เลขไมล์</td>
                                    <td className={tdInputClass}>
                                        <NumericFormat value={car_miles} className={inputClass}
                                            decimalScale={2} allowNegative={false} thousandSeparator=","
                                            onValueChange={(values) => setCarMiles(values.value)} />
                                    </td>
                                </tr>
                                <tr className='border-b border-gray-100'>
                                    <td className={tdLabelClass}>ทะเบียนเก่า/ใหม่</td>
                                    <td className={tdInputClass}>
                                        <input type='text' maxLength={255} className={inputClass}
                                            value={car_license_plate} onChange={(e) => setCarLicensePlate(e.target.value)} />
                                    </td>
                                </tr>
                                <tr className='border-b border-gray-100'>
                                    <td className={tdLabelClass}>เจ้าของเดิม/โทร</td>
                                    <td className={tdInputClass}>
                                        <input type='text' maxLength={255} className={inputClass}
                                            value={car_owner_old} onChange={(e) => setCarOwnerOld(e.target.value)} />
                                    </td>
                                </tr>
                                <tr className='border-b border-gray-100'>
                                    <td className={tdLabelClass}>เจ้าของใหม่/โทร</td>
                                    <td className={tdInputClass}>
                                        <input type='text' maxLength={255} className={inputClass}
                                            value={car_owner_new} onChange={(e) => setCarOwnerNew(e.target.value)} />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <hr className='border-gray-200 mb-4' />

                {/* Expense + Income — 2 columns */}
                <div className='grid grid-cols-1 md:grid-cols-2 gap-4 mb-4'>
                    <div>
                        <p className='text-center text-sm font-bold text-red-600 mb-2'>รายการจ่าย</p>
                        {is_expense === '0'
                            ? <p className='text-center text-sm text-gray-400'>สิทธิ์ของท่านไม่สามารถเพิ่มรายจ่ายได้</p>
                            : <table className='w-full'><tbody>{expense.map(ex => genExpenseInput(ex))}</tbody></table>
                        }
                    </div>
                    <div>
                        <p className='text-center text-sm font-bold text-green-600 mb-2'>รายการรับ</p>
                        {is_income === '0'
                            ? <p className='text-center text-sm text-gray-400'>สิทธิ์ของท่านไม่สามารถเพิ่มรายรับได้</p>
                            : <table className='w-full'><tbody>{income.map(inc => genIncomeInput(inc))}</tbody></table>
                        }
                    </div>
                </div>

                {/* Summary */}
                <div className='grid grid-cols-1 md:grid-cols-2 gap-4 mb-4'>
                    <div>
                        <table className='w-full'>
                            <tbody>
                                <tr className='border-b border-gray-100'><td className={tdLabelClass}>&nbsp;</td><td className={tdInputClass}>&nbsp;</td></tr>
                                <tr className='border-b border-gray-100'><td className={tdLabelClass}>&nbsp;</td><td className={tdInputClass}>&nbsp;</td></tr>
                                <tr className='border-b border-gray-100'>
                                    <td className='px-3 py-2 text-base font-bold text-gray-900 w-2/5 align-middle'>รวม</td>
                                    <td className='px-2 py-1.5'>
                                        <NumericFormat value={sum_expense} className='text-base font-bold text-gray-900 bg-transparent border-0 p-0 w-[200px]'
                                            decimalScale={2} allowNegative={false} thousandSeparator="," displayType='text' />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    {is_view_sum !== '0' && (
                        <div>
                            <table className='w-full'>
                                <tbody>
                                    <tr className='border-b border-gray-100'>
                                        <td className='px-3 py-2 text-base font-bold text-blue-600 w-2/5 align-middle'>รายรับ</td>
                                        <td className='px-2 py-1.5'>
                                            <NumericFormat value={sum_income} className='text-base font-bold text-blue-600 bg-transparent border-0 p-0 w-[200px]'
                                                decimalScale={2} allowNegative={false} thousandSeparator="," displayType='text' />
                                        </td>
                                    </tr>
                                    <tr className='border-b border-gray-100'>
                                        <td className='px-3 py-2 text-base font-bold text-red-600 w-2/5 align-middle'>รายจ่าย</td>
                                        <td className='px-2 py-1.5'>
                                            <NumericFormat value={sum_expense} className='text-base font-bold text-red-600 bg-transparent border-0 p-0 w-[200px]'
                                                decimalScale={2} allowNegative={false} thousandSeparator="," displayType='text' />
                                        </td>
                                    </tr>
                                    <tr className='border-b border-gray-100'>
                                        <td className={`px-3 py-2 text-base font-bold w-2/5 align-middle ${net_profit >= 0 ? 'text-green-600' : 'text-red-600'}`}>กำไรสุทธิ</td>
                                        <td className='px-2 py-1.5'>
                                            <NumericFormat value={net_profit} className={`text-base font-bold bg-transparent border-0 p-0 w-[200px] ${net_profit >= 0 ? 'text-green-600' : 'text-red-600'}`}
                                                decimalScale={2} allowNegative={true} thousandSeparator="," displayType='text' />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>

                <hr className='border-gray-200 mb-4' />

                {/* Action Buttons */}
                <div className='flex flex-wrap gap-2 justify-end mb-4'>
                    <Button variant='neutral' size='lg' icon={<FcSynchronize size='18' />} onClick={clearData}>
                        ล้างข้อมูล
                    </Button>
                    <Button variant='success' size='lg' icon={<FcAddRow size='18' />} onClick={() => saveCar()} disabled={formAction === 'edit'}>
                        เพิ่มข้อมูล
                    </Button>
                    <Button variant='primary' size='lg' icon={<FcEditImage size='18' />} onClick={() => saveCar()} disabled={formAction === 'add'}>
                        แก้ไขข้อมูล
                    </Button>
                    <Button variant='dark' size='lg' icon={<FcExport size='18' />} disabled={formAction === 'add'}
                        onClick={() => { if (is_export === "0") { AlertError('สิทธิ์ของท่านไม่สามารถ Export Excel ได้'); return } exportCar() }}>
                        Export Excel
                    </Button>
                </div>

            </div>
        </Layout>
    )
}

export default NewCar;
